import BookingFormPage from '@components/BookingFormPage/BookingFormPage';
import {NextSeo} from 'next-seo';
import AppConfigService from '@services/app-config.service';
import {getSeoOnPage} from '@helper/seo/seo';
import {useRouter} from 'next/router';

export default function DatLichKham(props) {
    const {seoPage} = props;
    const {locale} = useRouter();
    
    return (
        <>
            {seoPage && <NextSeo {...seoPage} />}
            <h1 className="sr-only">
                {locale === 'en' ? 'Book a medical appointment at TNH' : 'Đặt lịch khám tại TNH'}
            </h1>
            <BookingFormPage />
        </>
    );
}

DatLichKham.getInitialProps = async (context) => {
    try {
        const ctx = context || {};
        const appConfigService = new AppConfigService(ctx);
        const seoConfig = await appConfigService.getAppConfig({page: 'SEO'});
        
        let seoPage = getSeoOnPage('DATLICHKHAM', seoConfig);
        
        const webUrl = process.env.NEXT_PUBLIC_WEB_URL || 'https://tnh.com.vn';
        seoPage.canonical = `${webUrl}/dat-lich-kham`;
        if (seoPage.openGraph) {
            seoPage.openGraph.url = `${webUrl}/dat-lich-kham`;
        }
        
        return {seoPage};
    } catch (error) {
        console.error('Failed to fetch SEO for booking page:', error);
        return {seoPage: null};
    }
};
